import { useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import useLenis from "@/hooks/useLenis";
import { waLink } from "@/lib/api";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Simulator from "@/components/landing/Simulator";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import ExitIntent from "@/components/landing/ExitIntent";
import LeadForm from "@/components/landing/LeadForm";
import { Counters, Benefits, HowItWorks, Solutions, Projects, Testimonials, FAQ, TrustBadges, Coverage } from "@/components/landing/Sections";

const WA = "5575988623979";

export default function Landing() {
  useLenis();
  const [leadOpen, setLeadOpen] = useState(false);
  const [bill, setBill] = useState(null);

  const openLead = useCallback((b) => { setBill(b || null); setLeadOpen(true); }, []);
  const openWhatsapp = useCallback(() => {
    window.open(waLink(WA, "Olá! Vim pelo site e gostaria de um orçamento de energia solar."), "_blank");
  }, []);

  return (
    <div className="App bg-background">
      <Header onCta={() => openLead()} />
      <Hero onSimulate={() => document.getElementById("simulador")?.scrollIntoView({ behavior: "smooth" })} onWhatsapp={openWhatsapp} />
      <Counters />
      <TrustBadges />
      <Benefits />
      <HowItWorks />
      <Simulator onLead={openLead} />
      <Solutions onCta={() => openLead()} />
      <Projects />
      <Testimonials />
      <Coverage />
      <FAQ />
      <Footer onWhatsapp={openWhatsapp} />

      <WhatsAppButton onClick={openWhatsapp} />
      <ExitIntent />

      <AnimatePresence>
        {leadOpen && (
          <motion.div
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            className="fixed inset-0 z-[70] grid place-items-center p-4 bg-secondary/60 backdrop-blur-sm overflow-y-auto"
            onClick={() => setLeadOpen(false)}
            data-testid="lead-modal-overlay"
          >
            <motion.div
              initial={{ scale: 0.94, y: 20 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.94, opacity: 0 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              onClick={(e) => e.stopPropagation()}
              className="relative w-full max-w-lg my-8 rounded-3xl bg-white p-8 shadow-2xl"
              data-testid="lead-modal"
            >
              <button onClick={() => setLeadOpen(false)} className="absolute top-5 right-5 text-muted-foreground hover:text-secondary" data-testid="lead-modal-close"><X size={22} /></button>
              <h3 className="font-display font-bold text-3xl text-secondary tracking-tighter">Orçamento gratuito</h3>
              <p className="mt-2 text-muted-foreground">Preencha e nossa equipe entra em contato rapidinho.</p>
              <div className="mt-6">
                <LeadForm defaultBill={bill} testPrefix="lead-modal-form" onSuccess={() => setTimeout(() => setLeadOpen(false), 1200)} />
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
